import React, { useState, useEffect } from 'react';
import { apiRequest } from '../../utils/apiConfig';
import './ServerStats.scss';

const ServerStats = () => {
    const [statsData, setStatsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStats = async () => {
        try {
            setError(null);
            const response = await apiRequest('/stats');
            const data = await response.json();
            setStatsData(data);
            setLoading(false);
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
        const interval = setInterval(fetchStats, 60000); // Refresh every minute
        return () => clearInterval(interval);
    }, []);

    if (loading) {
        return (
            <div className="server-stats">
                <h2>Server Information</h2>
                <p>Loading server stats...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="server-stats">
                <h2>Server Information</h2>
                <p className="error">Error: {error}</p>
                <button onClick={fetchStats}>Retry</button>
            </div>
        );
    }

    return (
        <div className="server-stats">
            <h2>Server Information</h2>

            {statsData && (
                <div className="stats-grid">
                    <div className="stat-item">
                        <strong>Version:</strong> Minecraft {statsData.version || 'Unknown'}
                    </div>

                    <div className="stat-item">
                        <strong>Max Players:</strong> {statsData.maxPlayers || 'Unknown'}
                    </div>

                    <div className="stat-item">
                        <strong>World:</strong> {statsData.worldSize || 'Unknown'}
                    </div>

                    <div className="stat-item">
                        <strong>Game Time:</strong> {statsData.gameTime || 'Unknown'}
                    </div>

                    <div className="stat-item">
                        <strong>World Seed:</strong> {statsData.seed || 'Unknown'}
                    </div>

                    <div className="last-updated">
                        Last updated: {statsData.updatedAt ? new Date(statsData.updatedAt).toLocaleString() : 'N/A'}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServerStats;